import React from 'react'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
import Home from './pages/Home'
import Projects from './pages/Projects'
import ProjectDetails from './pages/ProjectDetails'
import ContactForm from './pages/ContactForm'
import Contact from './pages/Contact'
import About from './pages/About'
import Assistant from './pages/Assistant'
import PortfolioLayout from './components/PortfolioLayout'
import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<PortfolioLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/Projects" element={<Projects />} />
          <Route path="/Projects/:title" element={<ProjectDetails />} />
          <Route path="/ContactForm" element={<ContactForm />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/About" element={<About />} />
        </Route>

        {/* Standalone. Deliberately unlinked from the portfolio nav. */}
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/Assistant" element={<Assistant />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
